export default {
  //产品banner
  productsBanner: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/product/products-banner.vue'));
    }, '/modules/product/products-banner');
  },
  //产品列表
  productsList: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/product/productslist/list.vue'));
    }, '/modules/product/productslist/list');
  },
  productsFtList: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/product/productslist/list-ft.vue'));
    }, '/modules/product/productslist/list-ft');
  },
  //产品分类
  productCategory: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/product/category/list.vue'));
    }, '/modules/product/category/list');
  },
  //产品分类
  productFtCategory: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/product/category/list-ft.vue'));
    }, '/modules/product/category/list-ft');
  },
  productOther: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/product/productslist/other-list.vue'));
    }, '/modules/product/productslist/other-list');
  }
  // productsIndex: resolve => {
  //   require.ensure([], () => {
  //     resolve(require('@/views/product/products-index.vue'));
  //   }, '/modules/product/products-index');
  // }
}



// WEBPACK FOOTER //
// ./src/router/modules/product.js